#import "../fragments/audience-basic.graphql"

mutation SelectCreateAudience($audience: AudienceCreateInput!) {
    audienceCreate(input: $audience) {
        audience {
            ...AudienceBasic
        }
    }
}
